import { SERVICE_IDENTITY } from './host-overrides';

function getHostOverrides(): Record<string, string> {
  return (globalThis as { HOST_OVERRIDES?: Record<string, string> }).HOST_OVERRIDES ?? {};
}

export function resolveRpcHost(rpcPath: string, env: string): string {
  const fullService = rpcPath.split('/')[0];
  const identity = SERVICE_IDENTITY[fullService];

  const name =
    identity?.name ??
    fullService
      .split('.')
      .slice(0, -1)
      .filter((p) => !/^v\d+/.test(p))
      .join('-')
      .replace(/_/g, '-');

  const local = getHostOverrides()[name];
  if (local) {
    return local;
  }

  if (identity?.host) {
    const host = identity.host.replace('${ENV}', env);
    return host.startsWith('https://') ? host : `https://${host}`;
  }

  return `https://${name}-${env}.apigateway.co`;
}
